
export enum UploadStatus  {  
  waiting ='waiting',
  uploading = 'uploading',
  error = 'error',
  success = 'success'
}